<template>
  <div class="text-left">
    <appointmentModal
      :item="appointmentDetail"
      @detailEdited="setAppointmentList()"
    ></appointmentModal>
    <div class="ml-auto mb-3 d-flex justify-content-between">
      <b-button variant="primary" :disabled="editBlock" v-b-toggle.edit-hours>
        {{ $t("header.edit") }} {{ $t("subMenu.my_salon_appointment") }}
        {{ $t("header.booking_hour") }}
      </b-button>
      <exportCSV
        class="link btn buttons-csv buttons-html5 btn-primary mr-2"
        :data="exportData"
        :fields="exportFields"
        :header="exportHeaders"
        type="csv"
        :escapeCsv="false"
        :name="exportFileName"
      >
        <span>CSV</span>
      </exportCSV>
      <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                <span class="mr-3">PDF</span>
                <i class="arrow-down fas fa-angle-down"></i> 
            </button> -->
    </div>
    <div class="ml-auto mb-3 d-flex justify-content-between">
      <b-collapse
        id="edit-hours"
        class="mt-2 w-100 p-3"
        style="border-radius: 25px; background-color: #ececec"
      >
        <div class="d-flex justify-content-between mb-3 col-md-12">
          <multiselect
            v-model="hoursOutlet"
            label="text"
            track-by="id"
            :options="hourOutlet"
            :searchable="false"
            :show-labels="false"
            :allow-empty="false"
            openDirection="below"
            @select="getApptHours"
            class="col-md-4"
          >
            <template slot="option" slot-scope="{ option }">{{
              option.text
            }}</template>
            <span slot="noResult">{{ $t("table.no_records") }}</span>
          </multiselect>
          <select
            name="predefinedHours"
            class="form-control col-md-4"
            v-model="predefinedHours"
          >
            <option value="" disabled>--Auto Set Hours--</option>
            <option value="1">9 AM to 5 PM</option>
            <option value="2">10 AM to 6 PM</option>
            <option value="3">All</option>
          </select>
        </div>
        <template v-if="spinnerHour"
          ><div class="col-lg-12 d-flex justify-content-center">
            <b-spinner label="Loading..."></b-spinner></div
        ></template>
        <template v-if="hoursOutlet.id != '' && !spinnerHour">
          <div class="d-flex justify-content-center flex-wrap px-6">
            <div class="hourButtons">
              <b-button
                pill
                variant="outline-primary"
                :class="apptHours[0].appt ? 'active' : ''"
                class="m-2 my-1 w-100"
                @click="hourToggle(0)"
                >12:00AM</b-button
              >
            </div>
            <div class="hourButtons" v-for="index in 11" :key="index">
              <b-button
                pill
                variant="outline-primary"
                :class="apptHours[index].appt ? 'active' : ''"
                class="m-2 my-1 w-100"
                @click="apptHours[index].appt = !apptHours[index].appt"
                >{{ index }}:00AM</b-button
              >
            </div>
          </div>
          <div class="d-flex justify-content-center flex-wrap px-6">
            <div class="hourButtons">
              <b-button
                pill
                variant="outline-primary"
                :class="apptHours[12].appt ? 'active' : ''"
                class="m-2 my-1 w-100"
                @click="apptHours[12].appt = !apptHours[12].appt"
                >12:00PM</b-button
              >
            </div>
            <div class="hourButtons" v-for="index in 11" :key="index">
              <b-button
                pill
                variant="outline-primary"
                :class="apptHours[index + 12].appt ? 'active' : ''"
                class="w-100 my-1 m-2"
                @click="
                  apptHours[index + 12].appt = !apptHours[index + 12].appt
                "
                >{{ index }}:00PM</b-button
              >
            </div>
          </div>
          <div class="d-flex justify-content-end">
            <b-button variant="primary" @click="updateApptHours(apptHoursClone)"
              >Apply</b-button
            >
          </div>
        </template>
      </b-collapse>
    </div>
    <div class="row text-left mb-2" v-if="tab == 'list'">
      <div class="col-sm-12 col-md-12 mb-3">
        <div class="dataTables_filter">
          <label class="d-flex mb-0">
            <input
              type="text"
              class="form-control border-top-right-radius-0 border-bottom-right-radius-0 ml-0 shadow-inset-1"
              :placeholder="
                $t('label.search') +
                $t('label.customer_name') +
                '/Mobile Number'
              "
              v-model="searchCustomer"
            />
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-4 mb-3">
        <date-range-picker
          class="w-100"
          ref="picker"
          v-model="dateRange"
          :opens="'right'"
          :autoApply="true"
          :ranges="range"
          :showDropdowns="true"
          :always-show-calendars="false"
          :locale-data="{ firstDay: 1, format: 'dd/mm/yyyy' }"
          @showCustomRange="showCustomRangeCalendars = true"
          @update="filterByDate"
        >
        </date-range-picker>
      </div>
      <div class="col-sm-12 col-md-4 mb-2">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend w-100">
              <label class="input-group-text border-right-0">
                <i class="fas fa-store"></i>
              </label>
              <multiselect
                v-model="selectedOutlet"
                label="text"
                track-by="id"
                :options="outlet"
                :searchable="false"
                :show-labels="false"
                :allow-empty="false"
                openDirection="below"
                @select="filterByOutlet"
              >
                <template slot="option" slot-scope="{ option }">{{
                  option.text
                }}</template>
              </multiselect>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-4 mb-2">
        <div class="form-group">
          <div class="input-group">
            <div class="input-group-prepend w-100">
              <label class="input-group-text border-right-0">
                <i class="fas fa-user"></i>
              </label>
              <multiselect
                v-model="selectedStaff"
                :options="staffs"
                track-by="staffID"
                label="name"
                :show-labels="false"
                :allow-empty="false"
                openDirection="below"
                @select="filterByStaff"
              >
                <template slot="option" slot-scope="{ option }"
                  >{{ option.name
                  }}<b-badge
                    pill
                    variant="danger"
                    class="ml-2"
                    v-if="option.total != 'all'"
                    >{{ option.total }}</b-badge
                  ></template
                >
                <span slot="noResult">{{ $t("table.no_records") }}</span>
              </multiselect>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 mb-2 d-flex align-items-end">
        <b-form-group :label="''" v-slot="{ ariaDescribedby }">
          <b-form-radio-group
            class="mb-2"
            id="rad_status"
            v-model="selectedStatus"
            :options="radStatus"
            :aria-describedby="ariaDescribedby"
            name="rad_status"
            @change="setAppointmentList()"
          ></b-form-radio-group>
        </b-form-group>
      </div>
      <a class="col-sm-12 col-md-4 link text-primary" @click="clearFilter()">{{
        $t("button_link.clear_filter")
      }}</a>
    </div>
    <template v-if="tab == 'calendar' && totalEntries !== 0">
      <CalendarView @eventDetail="modalTrigger"></CalendarView>
    </template>
    <template v-if="tab == 'scheduler'">
      <!-- <SchedulerView :items="apptLists" :staffs="staffs"></SchedulerView> -->
    </template>
    <template v-else-if="tab == 'list'">
      <div class="dataTables_wrapper dt-bootstrap4">
        <div class="row justify-content-between mt-2">
          <div class="d-flex py-2 pl-3">
            <b-button-group size="sm">
              <b-button
                variant="outline-primary"
                :class="apptSource == '' ? 'active' : ''"
                @click="apptSource = ''"
                >All</b-button
              >
              <b-button
                variant="outline-primary"
                :class="apptSource == 'OL' ? 'active' : ''"
                @click="apptSource = 'OL'"
                >Online</b-button
              >
              <b-button
                variant="outline-primary"
                :class="apptSource == 'EM' ? 'active' : ''"
                @click="apptSource = 'EM'"
                >Emerchant</b-button
              >
            </b-button-group>
          </div>
          <div class="d-flex">
            <div class="col-auto pt-2">
              <span>{{
                $t("table.pagination", {
                  startPage: startPage,
                  endPage: endPage,
                  totalEntries: totalEntries,
                })
              }}</span>
            </div>
            <div class="col-auto">
              <b-pagination
                class="ml-3"
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalEntries"
                @input="handlePagination"
              ></b-pagination>
            </div>
          </div>
        </div>
        <div class="row" v-if="!isSpinnerShow && totalEntries != 0">
          <div class="col-sm-12 overflow-auto">
            <b-table
              striped
              hover
              bordered
              class="apptTable"
              :fields="fields"
              :items="apptLists"
              :per-page="perPage"
              :current-page="currentPage"
              responsive="md"
            >
              <template #cell(index)="data">
                {{ data.index + startPage }}
              </template>
              <template #cell(member)="data">
                {{ data.item.member }}
              </template>
              <template #cell(outlet)="data">
                {{ getOutlet(data.item.outletID) }}
              </template>
              <template #cell(createDate)="data">
                <span>{{
                  formatDate(
                    data.item.createDate,
                    "DD/MM/YYYY",
                    data.item.timezone
                  )
                }}</span>
              </template>
              <template #cell(arrivalDate)="data">
                <span
                  >{{
                    formatDate(
                      data.item.arrivalDate,
                      "DD/MM/YYYY hh:mm a",
                      data.item.timezone
                    )
                  }}
                  -
                  {{
                    durationCalc(data.item.arrivalDate, data.item.duration)
                  }}</span
                >
              </template>
              <template #cell(reminderDate)="data">
                <span>{{
                  formatDate(
                    data.item.reminderDate,
                    "DD/MM/YYYY",
                    data.item.timezone
                  )
                }}</span>
              </template>
              <template #cell(staffName)="data">
                <span>{{ data.item.staff }}</span>
              </template>
              <template #cell(sku)="data">
                <span>{{ data.item.sku }}</span>
              </template>
              <template #cell(source)="data">
                <span
                  class="badge badge-success fw-400"
                  v-if="data.item.source == 'OL'"
                  >{{ $t("label.online") }}</span
                >
                <span
                  class="badge badge-success fw-400"
                  v-if="data.item.source == 'EM'"
                  >Emerchant</span
                >
                <span
                  class="badge badge-primary fw-400"
                  v-else-if="data.item.source == 'TL'"
                  >{{ $t("salon_report.stock.manual") }}</span
                >
              </template>
              <template #cell(blocked)="data">
                <span
                  class="badge badge-success fw-400"
                  v-if="data.item.blocked != 0"
                  >{{ $t("button_link.yes") }}</span
                >
                <span class="badge badge-danger fw-400" v-else>{{
                  $t("button_link.no")
                }}</span>
              </template>
              <template #cell(action)="data">
                <b-button
                  @click="data.toggleDetails"
                  tabindex="0"
                  variant="outline-primary"
                >
                  <i class="fal fa-pencil fs-xl"></i>
                </b-button>
                <!-- <b-button
                                 v-b-modal.appointmentModal
                  :disabled="editBlock"
                  @click="appointmentDetail = data.item"
                  tabindex="0"
                  variant="outline-primary"
                >
                  <i class="fal fa-pencil fs-xl"></i>
                </b-button> -->
              </template>
              <template #cell(status)="data">
                <span
                  class="badge badge-success fw-400"
                  v-if="data.item.completedDate != 0"
                  >{{ $t("appointment.option_status_filter[1].text") }}</span
                >
                <span
                  class="badge badge-warning fw-400"
                  v-else-if="data.item.noshowDate !== 0"
                  >{{ $t("appointment.option_status_filter[3].text") }}</span
                >
                <span class="badge badge-primary fw-400" v-else>{{
                  $t("label.approved")
                }}</span>
              </template>
              <template #row-details="row">
                <b-card>
                  <div class="row">
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <label class="font-weight-bold">Name</label>
                        <span>
                          {{ row.item.member }}
                        </span>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <label class="font-weight-bold"> Staff Name </label>
                        <span>
                          {{ row.item.staff }}
                        </span>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <label class="font-weight-bold"> Mobile </label>
                        <span>
                          {{ row.item.mobile }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <div class="d-flex">
                          <label class="font-weight-bold">Appointment Date</label>
                          <!-- <a class="link text-primary ml-1">
                            <b-icon variant="primary" icon="pencil"></b-icon>
                          </a> -->
                        </div>
                        <span>
                          {{
                            formatDate(
                              row.item.arrivalDate,
                              "DD MMM YYYY hh:mm:ss a",
                              row.item.timezone
                            )
                          }}
                          ({{ row.item.duration }} Minutes)
                        </span>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <label class="font-weight-bold"> Create Date </label>
                        <span>
                          {{
                            formatDate(
                              row.item.createDate,
                              "DD MMM YYYY hh:mm:ss a",
                              row.item.timezone
                            )
                          }}
                        </span>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <label class="font-weight-bold"> Reminder Date </label>
                        <span>
                          {{
                            formatDate(
                              row.item.reminderDate,
                              "DD MMM YYYY",
                              row.item.timezone
                            )
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-4">
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <label class="font-weight-bold"> Source </label>
                        <div>
                          <span
                            class="badge badge-success fw-400"
                            v-if="row.item.source == 'OL'"
                            >{{ $t("label.online") }}</span
                          >
                          <span
                            class="badge badge-success fw-400"
                            v-else-if="row.item.source == 'EM'"
                            >Emerchant</span
                          >
                          <span
                            class="badge badge-primary fw-400"
                            v-else-if="row.item.source == 'TL'"
                            >{{ $t("salon_report.stock.manual") }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <label class="font-weight-bold"> Status </label>
                        <div>
                          <span
                            class="badge badge-success fw-400"
                            v-if="row.item.completedDate != 0"
                            >Completed</span
                          >
                          <span
                            class="badge badge-warning fw-400"
                            v-else-if="row.item.noshowDate !== 0"
                            >No Show</span
                          >
                          <span class="badge badge-primary fw-400" v-else
                            >Approved</span
                          >
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-4">
                      <div class="d-flex flex-column">
                        <div class="d-flex">
                          <label class="font-weight-bold"> Color </label>
                          <!-- <a class="link text-primary ml-1">
                            <b-icon variant="primary" icon="pencil"></b-icon>
                          </a> -->
                        </div>
                        <span>
                          {{ row.item.color }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="row mt-4">
                    <div class="col-sm-6">
                      <div class="d-flex flex-column">
                        <div class="d-flex">
                          <label class="font-weight-bold"> Remarks </label>
                          <a class="link text-primary ml-1" v-b-modal.editRemarkModal @click.stop="editRemark(row.item)">
                            <b-icon variant="primary" icon="pencil"></b-icon>
                          </a>
                        </div>
                        <div>
                          {{ row.item.remarks !== "" ? row.item.remarks : "-" }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <template v-if="row.item.noshowDate === 0 && row.item.completedDate === 0" #footer>
                    <div class="d-flex justify-content-between w-100">
                      <b-button
                        class="mr-2"
                        pill
                        size="xs"
                        variant="outline-danger"
                        @click="emitDetail(row.item.bookID, 'delete')"
                        ><b-icon icon="trash"></b-icon></b-button>
                      <div>
                        <template v-if="emitCheckDate(row.item.arrivalDate)">
                          <b-button
                          class="mr-2"
                          pill
                          variant="warning"
                          @click="emitDetail(row.item.bookID, 'noshow')"
                          >No Show <i class="fa fa-times-circle fs-xl"></i
                        ></b-button>
                        <b-button
                          class="mr-2"
                          pill
                          variant="success"
                          @click="emitDetail(row.item.bookID, 'completed')"
                          >Completed <i class="fa fa-check-circle fs-xl"></i
                        ></b-button>
                        </template>
                        <b-button
                          class="mr-2"
                          pill
                          variant="danger"
                          v-if="row.item.blocked == 0"
                          @click="emitDetail(row.item.bookID, 'blocked')"
                          >Block <i class="fa fa-exclamation-triangle fs-xl"></i
                        ></b-button>
                      </div>
                    </div>
                  </template>
                </b-card>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </template>
    <b-modal
    id="editRemarkModal" size="md" title="Edit Remarks">
    <textarea name="" id="" cols="30" rows="6" v-model="appointmentEditForm.remark" class="form-control"></textarea>
        <template #modal-footer="{close}">
      <div class="d-flex w-100 justify-content-center">
          <b-button @click="close()" class="mr-1">Cancel</b-button>
          <b-button variant="primary" @click="saveEditRemark()">Save</b-button>
        </div>
      </template>
    </b-modal>
    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
      {{ $t("table.no_records") }}
    </div>

  </div>
</template>
<script>
import moment from "moment-timezone";
import DateRangePicker from "vue2-daterange-picker";
import CalendarView from "./fullCalendar";
import {
  handleSessionExpired,
  setReturnData,
  getOutletList,
  getStaffList,
} from "./../../../../assets/js/dashboard/dashboard.js";
import AppointmentModal from "./Appointment_Modal";
import Swal from "sweetalert2";
export default {
  name: "appointmentFilter",
  props: {
    tab: String,
  },
  components: {
    DateRangePicker,
    CalendarView,
    AppointmentModal,
  },
  data() {
    let now = moment();

    let dateRange = {
      startDate: now.startOf("month").toDate(),
      endDate: now.endOf("month").toDate(),
    };
    return {
      editBlock: false,
      appointmentDetail: {},
      appointmentEditForm:{
        remark:""
      },
      outletID: "",
      staffID: "",
      outlet: [],
      staffs: [],
      dateRange,
      selectedTabView: "active",
      selectedOutlet: {
        text: "",
        bizName: "",
        id: "",
      },
      searchAppt: "",
      isSpinnerShow: false,
      spinnerHour: false,
      searchFilter: "",
      searchCustomer: "",
      selectedVisit: "",
      selectedStaff: {
        staffID: "",
        name: "All Staffs",
        deleteDate: 0,
      },
      selectedStatus: "all",
      apptData: [],
      apptLists: [],
      apptHours: [],
      apptHoursClone: [],
      page: 0,
      totalEntries: 0,
      totalPage: 0,
      startPage: 1,
      endPage: 0,
      perPage: 50,
      currentPage: 1,
      exportHeaders: [],
      exportData: [],
      exportFileName: "",
      apptExportData: [],
      skuList: [],
      hoursOutlet: {
        text: "Select Outlet",
        bizName: "Select Outlet",
        id: "",
      },
      predefinedHours: "",
      apptSource: "",
      source: "",
    };
  },
  computed: {
    hourOutlet() {
      let array = [
        {
          text: "Select Outlet",
          bizName: "Select Outlet",
          id: "",
        },
      ];
      array = array.concat(JSON.parse(this.$store.state.outlets));
      return array;
    },
    radStatus() {
      return this.$i18n.messages[this.$i18n.locale].appointment
        .option_status_filter;
    },
    range() {
      let now = moment();
      return {
        Today: [moment().toDate(), moment().toDate()],
        Yesterday: [
          moment().subtract(1, "days").toDate(),
          moment().subtract(1, "days").toDate(),
        ],
        Tomorrow: [
          moment().add(1, "days").toDate(),
          moment().add(1, "days").toDate(),
        ],
        "Last 7 Days": [
          moment().subtract(6, "days").toDate(),
          moment().toDate(),
        ],
        "Last 30 Days": [
          moment().subtract(29, "days").toDate(),
          moment().toDate(),
        ],
        "This Week": [now.startOf("week").toDate(), now.endOf("week").toDate()],
        "This Month": [
          moment().startOf("month").toDate(),
          moment().endOf("month").toDate(),
        ],
        "This Year": [now.startOf("year").toDate(), now.endOf("year").toDate()],
        "Last Week": [
          moment().subtract(1, "week").startOf("week").toDate(),
          moment().subtract(1, "week").endOf("week").toDate(),
        ],
        "Last Month": [
          moment().subtract(1, "month").startOf("month").toDate(),
          moment().subtract(1, "month").endOf("month").toDate(),
        ],
        "Last Year": [
          moment().subtract(1, "year").startOf("year").toDate(),
          moment().subtract(1, "year").endOf("year").toDate(),
        ],
        "Next Week": [
          moment().add(1, "week").startOf("week").toDate(),
          moment().add(1, "week").endOf("week").toDate(),
        ],
        "Next Month": [
          moment().add(1, "month").startOf("month").toDate(),
          moment().add(1, "month").endOf("month").toDate(),
        ],
        "Next Year": [
          moment().add(1, "year").startOf("year").toDate(),
          moment().add(1, "year").endOf("year").toDate(),
        ],
      };
    },
    fields() {
      return [
        {
          key: "index",
          label: "#",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "member",
          label: this.$i18n.t("label.name"),
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
          sortable: true,
        },
        {
          key: "mobile",
          label: this.$i18n.t("Mobile"),
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
          sortable: true,
        },
        // {
        //   key: "createDate",
        //   label: "Create Date",
        //   thClass: "thead-themed align-middle",
        //   tdClass: "align-middle",
        // },
        {
          key: "arrivalDate",
          label: "Appointment Date",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        // {
        //   key: "reminderDate",
        //   label: "Reminder Date",
        //   thClass: "thead-themed align-middle",
        //   tdClass: "align-middle",
        // },
        {
          key: "staffName",
          label: "Staff Name",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle",
        },
        {
          key: "sku",
          label: "Service",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle text-center",
        },
        {
          key: "status",
          label: "Status",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle text-center",
        },
        {
          key: "blocked",
          label: "Blocked",
          thClass: "thead-themed align-middle",
          tdClass: "align-middle text-center",
        },
        // {
        //   key: "source",
        //   label: "Source",
        //   thClass: "thead-themed align-middle",
        //   tdClass: "align-middle text-center",
        // },
        {
          key: "action",
          label: " Action",
          thClass: "thead-themed align-middle",
          tdClass: " align-middle text-center",
        },
      ];
    },
    exportFields() {
      var ret = {};
      ret["#"] = "index";
      ret["NAME"] = "name";
      ret["CREATE_DATE"] = "createDate";
      ret["ARRIVAL_DATE"] = "arrivalDate";
      ret["STAFF_NAME"] = "staff";
      ret["SKU"] = "sku";
      ret["OUTLET"] = "outlet";

      return ret;
    },
  },
  watch: {
    searchCustomer(val) {
      this.apptLists = this.apptData.filter((item) => {
        let member = item.member.toUpperCase();
        let search = val.toUpperCase();
        if (item.mobile.includes(val) || member.includes(search)) {
          return item;
        }
      });
      this.totalEntries = this.apptLists.length;
    },
    apptSource(val) {
      this.setAppointmentList();
    },
    predefinedHours(val) {
      switch (val) {
        case "1":
          for (let x = 0; x < 24; x++) {
            if (x > 8 && x < 18) {
              this.apptHours[x].appt = true;
            } else {
              this.apptHours[x].appt = false;
            }
          }
          break;
        case "2":
          for (let x = 0; x < 24; x++) {
            if (x > 9 && x < 19) {
              this.apptHours[x].appt = true;
            } else {
              this.apptHours[x].appt = false;
            }
          }
          break;
        case "3":
          for (let x = 0; x < 24; x++) {
            this.apptHours[x].appt = true;
          }
      }
    },
  },
  methods: {
    async saveEditRemark(){
      let $vm = this;
      var result = {};
      let url = this.$api.BOOKING + "/" + this.appointmentEditForm.id + "/" + "remarks";
      let body = {
            remarks:$vm.appointmentEditForm.remark
          };
      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: "https://appt.tunai.io/",
          data:body,
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          result = response;
        })
        .catch((err) => {
          this.toastrExe(
            "Appointment Update",
            `Update for Book ID:${$vm.appointmentEditForm.id} Failed`,
            "danger"
          );
          result = err.response;
          var errData = err.response?.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
        if(result.status === 200)
        this.toastrExe(
            "Appointment Update",
            `Book ID:${$vm.appointmentEditForm.id} remarks edited`,
            'success'
          );
        this.setAppointmentList();
        this.$bvModal.hide("editRemarkModal");
    },
    editRemark(row){
      this.appointmentEditForm.id = row.bookID;
      this.appointmentEditForm.remark = row.remarks;
    },
    emitCheckDate(date){
      let arrival = new Date(date).getTime();
      let now = new Date().getTime();
      if(arrival <= now){
        return true;
      }     
      else{
        return false;
      }
    },
    filterByOutlet(val) {
      this.outletID = val.id;
      this.selectedOutlet = val;
      this.selectedStaff = {
        staffID: "",
        name: "All Staffs",
      };
      this.staffID = "";
      this.setAppointmentList();
    },
    filterByStaff(val) {
      this.staffID = val.staffID;
      this.setAppointmentList();
    },
    hourToggle(index) {
      this.apptHours[index].appt = !this.apptHours[index].appt;
    },
    modalTrigger(data) {
      this.appointmentDetail = this.apptData.filter((item) => {
        if (item.bookID == data.id) return item;
      })[0];
      this.$bvModal.show("appointmentModal");
    },
    searchingFunc(obj, value) {
      for (let key in obj) {
        if (!Number.isInteger(obj[key]) && !(typeof obj[key] === "object")) {
          if (obj[key].toUpperCase().indexOf(value) != -1) {
            return true;
          }
        }
      }
      return false;
    },
    formatDate(date, format, tz) {
      let now = moment(date).tz(tz).format(format);
      return now;
    },
    durationCalc(date, duration) {
      let hours = moment(date).add(duration, "minutes").format("hh:mm a");
      return hours;
    },
    async setAppointmentList() {
      this.isSpinnerShow = true;
      let $vm = this;
      this.outlet = [];
      this.outlet = this.outlet.concat(JSON.parse(this.$store.state.outlets));
      this.selectedOutlet =
        this.selectedOutlet.id == "" ? this.outlet[0] : this.selectedOutlet;
      if (this.outletID == "") {
        this.outletID = this.outlet[0].id;
      }
      var result = await this.getAppointmentList();
      this.apptLists = result.books;
      const sku = result.skus;
      this.$emit("skuList", sku);
      this.$emit("selectedOutlet", this.selectedOutlet);
      const members = result.members;
      const staffs = JSON.parse(this.$store.state.staffs);
      const colors = result.colors;
      this.staffs = [
        { staffID: "", name: "All Staffs", total: "all", deleteDate: 0 },
      ];
      this.staffs = this.staffs.concat(staffs);
      // this.staffs = this.staffs.filter(staff => {
      //   if(staff.outletID == this.selectedOutlet.id)
      //   return staff;
      // });

      this.apptLists.forEach((books) => {
        books.arrivalDate = moment(new Date(books.arrivalDate * 1000)).format();
        books.createDate = moment(new Date(books.createDate * 1000)).format();
        books.reminderDate = moment(
          new Date(books.reminderDate * 1000)
        ).format();
        books.sku = sku.filter((item) => {
          if (item.skuID == books.skuID) return item;
        })[0].name;
        var member = members.filter((item) => {
          if (item.memberID == books.memberID) return item;
        })[0];
        books.member = member.name == "" ? member.mobile : member.name;
        books.mobile = member.mobile;
        books.staff = staffs.find((item) => {
          if (item.staffID == books.staffID) return item;
        });
        books.staff = books.staff != undefined ? books.staff.name : "-";
        books.color = colors.filter((item) => {
          if (item.colorID == books.colorID) return item;
        })[0].name;
        books.remarkEditView = false;
      });
      this.staffs = this.staffs.filter((s) => {
        if (s.outletID == this.outletID || s.total == "all") {
          return s;
        }
      });
      this.staffs.forEach((s) => {
        if (s.total != "all")
          s.total = this.apptLists.filter((item) => {
            if (item.staffID == s.staffID) {
              return item;
            }
          }).length;
      });
      this.staffs.sort((a, b) => {
        return b.total - a.total;
      });

      this.apptLists = this.apptLists.filter((item) => {
        if (
          item.staffID.toString().includes(this.staffID) &&
          item.outletID.toString().includes(this.outletID) &&
          item.source.toString().includes(this.apptSource)
        ) {
          switch (this.selectedStatus) {
            case "all":
              return item;

            case "completed":
              if (item.completedDate != 0) return item;
              break;
            case "noshow":
              if (item.noshowDate != 0) return item;
              break;
            case "approved":
              if (item.completedDate === 0 && item.noshowDate === 0)
                return item;
          }
        }
      });
      this.apptData = JSON.parse(JSON.stringify(this.apptLists));
      var retData = setReturnData(
        this.apptLists,
        this.apptLists.length,
        this.page
      );

      this.totalEntries = retData.count;
      this.totalPage = retData.totalPage;

      this.startPage = this.totalEntries > 0 ? retData.startPage : 0;
      this.endPage =
        this.perPage > this.totalEntries ? this.totalEntries : this.perPage;

      this.isSpinnerShow = false;
      var exportResult = this.apptLists;
      this.apptExportData = exportResult;
      this.setExportData(exportResult);
    },
    handlePagination(pg) {
      if (pg != null) {
        this.page = pg;
        this.startPage = (pg - 1) * 50 + 1;
        this.endPage = pg * 50;
        if (this.endPage > this.totalEntries) {
          this.endPage = this.totalEntries;
        }
        // this.filterMemberList(this.selectedMembershipTab, this.selectedVisit, this.searchFilter, this.birthdayFilter);
        //document.getElementById('btnToTop').click();
      }
    },
    setExportData(data) {
      this.exportData = [];
      let header =
        this.$msg.REPORT.HEADER + this.$i18n.t("subMenu.my_salon_appointment");
      this.exportHeaders = [
        header,
        this.$i18n.t("table.report_generate") +
          moment().format(this.$msg.CST.DATE_TIME_24),
        " ",
      ];

      this.exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV;

      for (var i = 0; i < data.length; i++) {
        this.exportData.push({
          index: i + 1,
          createDate: data[i].createDate,
          arrivalDate: data[i].arrivalDate,
          outlet:
            data[i].outletID == 0
              ? this.$i18n.t("label.all", {
                  item: this.$i18n.t("label.outlet"),
                })
              : this.getOutlet(data[i].outletID),
          name: data[i].member == "" ? "-" : data[i].member,
          staff: data[i].staff == "" ? "-" : data[i].staff,
          sku: data[i].sku,
          color: data[i].color,
        });
      }
    },
    getOutlet(id) {
      return this.outlet.filter((obj) => obj.id == id)[0].bizName;
    },
    async getApptHours(event) {
      this.spinnerHour = true;
      let url = `https://bebusiness.tunai.io/outlet/${event.id}/bookhour`;
      let result = [];
      await this.$axios({
        method: "get",
        url: url,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data.hours;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.apptHours = result;
      this.apptHours.forEach((appt) => {
        appt.appt = appt.appt == 1 ? true : false;
      });
      this.apptHoursClone = JSON.parse(JSON.stringify(this.apptHours));
      this.spinnerHour = false;
    },
    async updateApptHours() {
      let hours = [];
      let body = {};
      let url = "";
      let flag = false;
      let result = null;
      let appt = this.apptHours;
      let apptClone = this.apptHoursClone;
      for (var x = 0; x < appt.length; x++) {
        appt[x].appt = appt[x].appt ? 1 : 0;
        hours.push(appt[x]);
      }
      if (hours.length == 1) {
        url = `https://bebusiness.tunai.io/outlet/${this.hoursOutlet.id}/bookhour/${hours[0].hourID}/appt`;
        body = {
          appt: hours[0].appt.toString(),
        };
      } else if (hours.length > 1) {
        let ids = [];
        hours.filter((item) => {
          if (item.appt == 1 || item.appt) {
            ids.push(item.hourID);
          }
        });
        url = `https://bebusiness.tunai.io/outlet/${this.hoursOutlet.id}/bookhour/batch`;
        body = {
          batch: ids,
        };
      } else {
        this.toastrExe(
          "Appointment Hours Update",
          "No changes applied",
          "warning"
        );
        return;
      }
      await this.$axios({
        method: "post",
        url: url,
        data: body,
        headers: { token: this.$session.get("token") },
      })
        .then(function (response) {
          result = response.data;
        })
        .catch((err) => {
          flag = true;
          var errData = err.response.data;
          if (errData.error == this.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      if (flag) {
        this.toastrExe(
          "Appointment Hours Update",
          "Error during submission",
          "danger"
        );
      } else {
        this.toastrExe(
          "Appointment Hours Update",
          "Successfully updated appointment hours",
          "success"
        );
      }
      this.getApptHours(this.hoursOutlet);
    },
    async emitDetail(bookID, operation) {
      let flag = false;
      let text = "";
      if(operation === 'noshow')
      text="'no show'"
      else if(operation === 'completed')
      text="complete"
      else if(operation === 'delete')
      text="delete"
      else if(operation === 'blocked')
      text="block"

      await Swal.fire({
        title: `Confirm ${text} appointment?`,
        showCancelButton: true,
        confirmButtonText: "Confirm",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          flag = true;
        } else if (result.isDismissed) {
          flag = false;
        }
      });
      if (!flag) {
        return;
      }
      let $vm = this;
      var result = {};
      let url = this.$api.BOOKING + "/" + bookID + "/" + operation;
      await $vm
        .$axios({
          method: "post",
          url: url,
          baseURL: "https://appt.tunai.io/",
          headers: { token: $vm.$session.get("token") },
        })
        .then((response) => {
          this.toastrExe(
            "Appointment Update",
            operation == "delete"
              ? `Book ID:${bookID} has been deleted`
              : `Update for Book ID:${bookID} Successful`,
            "success"
          );
          result = response;
        })
        .catch((err) => {
          this.toastrExe(
            "Appointment Update",
            `Update for Book ID:${bookID} Failed`,
            "danger"
          );
          result = err.response;
          var errData = err.response?.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
        if(result.status === 200)
        this.setAppointmentList();
    },
    async getAppointmentList() {
      let $vm = this;
      let QUERY_STRING = "";
      if (this.dateRange.startDate != "" && this.dateRange.endDate != "") {
        this.dateRange.startDate.setHours(0, 0, 0, 0);
        this.dateRange.endDate.setHours(23, 59, 59, 999);
        QUERY_STRING =
          "?start=" +
          Date.parse(this.dateRange.startDate).toString().slice(0, 10) +
          "&stop=" +
          Date.parse(this.dateRange.endDate).toString().slice(0, 10);
      }

      if (this.outletID != 0) {
        QUERY_STRING = QUERY_STRING + "&outletID=" + this.outletID;
      }
      let url = this.$api.BOOKING + QUERY_STRING;

      var result = {};
      await $vm
        .$axios({
          method: "get",
          url: url,
          baseURL: "https://appt.tunai.io/",
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response.data;
        })
        .catch((err) => {
          var errData = err.response.data;
          if (errData.error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      return result;
    },
    clearFilter() {
      this.selectedOutlet = {
        text: "All Outlets",
        bizName: "All Outlets",
        id: "",
      };
      this.selectedStaff = {
        staffID: "",
        name: "All Staffs",
      };
      this.selectedStatus = "all";
      this.searchCustomer = "";
      this.apptSource = "";
      this.setAppointmentList();
    },
    filterByDate() {
      this.setAppointmentList();
    },
    autoSetDate(unix) {
      this.dateRange.startDate = new Date(unix * 1000);
      this.dateRange.endDate = new Date(unix * 1000);
      this.setAppointmentList();
    },
    toastrExe(title, body, variant) {
      this.$bvToast.toast(body, {
        title: title,
        variant: variant,
        solid: true,
      });
    },
  },
  mounted() {
    this.setAppointmentList();
    let blocks = this.$store.state.blockList;
    blocks.forEach((element) => {
      if (element == "biz.appt.edit") this.editBlock = true;
    });
  },
};
</script>
<style>
@media only screen and (max-width: 2300px) {
  .hourButtons {
    flex: 0 0 10%;
    max-width: 8%;
    padding: 5px;
  }
  .apptTable {
    font-size: 1em;
  }
}
@media only screen and (max-width: 1600px) {
  .hourButtons {
    flex: 0 0 25%;
    max-width: 25%;
    padding: 5px;
  }
  .apptTable {
    font-size: 0.9em;
  }
}
@media only screen and (max-width: 1300px) {
  .hourButtons {
    flex: 0 0 30%;
    max-width: 30%;
    padding: 5px;
  }
  .apptTable {
    font-size: 0.7em;
  }
}
@media only screen and (max-width: 800px) {
  .hourButtons {
    flex: 0 0 40%;
    max-width: 40%;
    padding: 5px;
  }
  .apptTable {
    font-size: 0.4em;
  }
}
</style>